import styled from 'styled-components';
import { layout } from 'src/components/base';

const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: ${layout.measurements.spacing050};
  margin-top: ${layout.measurements.spacing200};
`;

export default Title;
